import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { LanguageSwitcher } from '../../components/LanguageSwitcher';
import './LegalPage.css';

export function PrivacyPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Helper to render array items from locale
  const renderList = (key: string) => {
    const items = t(key);
    if (Array.isArray(items)) {
      return (
        <ul>
          {items.map((item: string, i: number) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      );
    }
    return null;
  };

  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <span className="legal-nav-logo" onClick={() => navigate('/')}>My Job Odyssey</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <LanguageSwitcher />
          <button className="legal-nav-back" onClick={() => navigate('/')}>
            &larr; {t('legal.backToHome')}
          </button>
        </div>
      </nav>

      <div className="legal-content">
        <h1>{t('legal.privacy.title')}</h1>
        <p className="legal-updated">{t('legal.lastUpdated')}</p>
        <p className="legal-intro">{t('legal.privacy.intro')}</p>

        <section className="legal-section">
          <h2>{t('legal.privacy.collectTitle')}</h2>
          <p>{t('legal.privacy.collectText')}</p>
          {renderList('legal.privacy.collectItems')}
        </section>

        <section className="legal-section">
          <h2>{t('legal.privacy.storageTitle')}</h2>
          <p>{t('legal.privacy.storageText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.privacy.useDataTitle')}</h2>
          <p>{t('legal.privacy.useDataText')}</p>
          {renderList('legal.privacy.useDataItems')}
        </section>

        <section className="legal-section">
          <h2>{t('legal.privacy.sharingTitle')}</h2>
          <p>{t('legal.privacy.sharingText')}</p>
          {renderList('legal.privacy.sharingItems')}
          <p>{t('legal.privacy.sharingExtra')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.privacy.matchingTitle')}</h2>
          <p>{t('legal.privacy.matchingText')}</p>
          {renderList('legal.privacy.matchingItems')}
        </section>

        <section className="legal-section">
          <h2>{t('legal.privacy.retentionTitle')}</h2>
          <p>{t('legal.privacy.retentionText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.privacy.rightsTitle')}</h2>
          <p>{t('legal.privacy.rightsText')}</p>
          {renderList('legal.privacy.rightsItems')}
        </section>

        <section className="legal-section">
          <h2>{t('legal.privacy.cookiesTitle')}</h2>
          <p>{t('legal.privacy.cookiesText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.privacy.childrenTitle')}</h2>
          <p>{t('legal.privacy.childrenText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.privacy.changesTitle')}</h2>
          <p>{t('legal.privacy.changesText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.privacy.contactTitle')}</h2>
          <p>{t('legal.privacy.contactText')}</p>
        </section>
      </div>

      <div className="legal-footer">
        &copy; {new Date().getFullYear()} {t('home.footer.copyright')}
      </div>
    </div>
  );
}
